export const START_FETCH_NEWS_SUBPAGE_DATA = "START_FETCH_NEWS_SUBPAGE_DATA";
export const SUCCESS_FETCH_NEWS_SUBPAGE_DATA = "SUCCESS_FETCH_NEWS_SUBPAGE_DATA";
export const ERROR_FETCH_NEWS_SUBPAGE_DATA = "ERROR_FETCH_NEWS_SUBPAGE_DATA";
